import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';

import { LinkBtn, Icon } from '../../components';
import { sendAlert } from '../../actions/utils';
import { showSelectionProcessRequest } from '../../requests/selectionProcesses';
import { createCandidateRequest } from '../../requests/candidates';
import { camelCaseEmptyStringRecursive } from '../../services/utils';

import CandidateForm from './CandidateForm';
import basicSelectionProcess from './basicSelectionProcess';
import basicCandidate from './candidate';

const CandidateNew = () => {
  const { id: selectionProcessId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [selectionProcess, setSelectionProcess] = useState(basicSelectionProcess);

  useEffect(() => {
    showSelectionProcessRequest(selectionProcessId, {
      dispatch,
      successCallback: response => setSelectionProcess(camelCaseEmptyStringRecursive(response.data))
    });
  }, [selectionProcessId, dispatch]);

  const handleSuccess = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    history.push(`/selection_processes/${selectionProcessId}`);
  };

  const handleFailure = error => {
    const { response } = error || {};
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message || 'Ocurrió un error' }));
  };

  const handleCreate = values => {
    const { resume } = values.candidate;
    const params = snakeCaseKeys(values.candidate);

    createCandidateRequest(selectionProcess.id, {
      dispatch,
      params: { candidate: { ...params, resume } },
      formData: true,
      successCallback: () => handleSuccess('Candidato creado con éxito'),
      failureCallback: handleFailure
    });
  };

  return (
    <>
      <Row className="mb-1 my-3 align-items-center">
        <Col xs="auto">
          <LinkBtn
            variant="circle-dark"
            className="btn-circle mt-3"
            block
            to={`/selection_processes/${selectionProcessId}`}
          >
            <Icon icon="chevron-back" />
          </LinkBtn>
        </Col>

        <Col xs={10}>
          <h2 className="mt-3">Nuevo Candidato</h2>
        </Col>
      </Row>
      <div className="yellow-wrapper mt-4">
        <Col>
          <CandidateForm
            candidate={basicCandidate}
            selectionProcess={selectionProcess}
            action="new"
            formRequest={handleCreate}
          />
        </Col>
      </div>
    </>
  );
};

export default CandidateNew;
